import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { IAlertSetting } from "./types/_setting";
const api = new APIClient();

const path = '/secured/setting';
const settingApi = {
  getAlertSetting(params: any = {}): Promise<AxiosResponse<ResponseData<IAlertSetting>, any>> {
    const url = `${path}`;
    return api.get(url, params)
  },
  postAlertSetting(dataForm: any): Promise<AxiosResponse<ResponseData<IAlertSetting>, any>> {
    const url = `${path}`;
    return api.post(url, dataForm)
  },
}
export default settingApi
